import { FirestoreProductSubject, SubjectSource } from "reedy-data/models";
import { BaseItem } from "~/components/sortable-list";
import { v4 } from "uuid";
import {
  qualifierTypes,
  subjectsType,
  SubjectSchemeIdentifier,
} from "~/integrations/firebase/collections/products";

export const filterQualifiers = (qualifiers: FirestoreProductSubject[]) => {
  return qualifiers.filter((s) =>
    qualifierTypes.includes(
      s.subjectSchemeIdentifier as SubjectSchemeIdentifier,
    ),
  );
};

export const filterSubjects = (subjects: FirestoreProductSubject[]) => {
  return subjects.filter((s) => s.subjectSchemeIdentifier === subjectsType);
};

export const createListItems = (items: FirestoreProductSubject[]): BaseItem[] =>
  items?.map((item) => ({
    id: item.id ?? "",
    value:
      item.subjectSchemeIdentifier === SubjectSchemeIdentifier.Keyword
        ? (item.subjectHeadingText ?? "")
        : (item.subjectCode ?? ""),
    description:
      item.subjectSchemeIdentifier === SubjectSchemeIdentifier.Keyword
        ? (item.subjectCode ?? "")
        : (item.subjectHeadingText ?? ""),
    infoText: item.rankingReasoning ?? "",
  }));

export const createManualSubject = (
  subject: string,
  identifier: SubjectSchemeIdentifier = SubjectSchemeIdentifier.Keyword,
): FirestoreProductSubject => {
  if (!subject?.trim()) {
    throw new Error("Subject cannot be empty");
  }
  return {
    id: v4(),
    subjectCode: null,
    subjectHeadingText: subject,
    subjectSchemeIdentifier: identifier,
    source: SubjectSource.MANUAL,
  };
};

export const createManualThemaSubject = (
  code: string,
  description: string,
  identifier: SubjectSchemeIdentifier,
  reasoning?: string,
): FirestoreProductSubject => {
  if (!code?.trim()) {
    throw new Error("Subject code cannot be empty");
  }
  if (!description?.trim()) {
    throw new Error("Subject description cannot be empty");
  }
  return {
    id: v4(),
    subjectCode: code,
    subjectHeadingText: description,
    subjectSchemeIdentifier: identifier,
    source: SubjectSource.MANUAL,
    reasoning: reasoning ?? null,
    ranking: null,
    rankingReasoning: null,
    keywordSearchQuery: null,
  };
};
